export const updateLogs ={
  "title": "What's New",
  "contents": "Contents"
}